module.exports = __webpack_public_path__ + "img/_4.80a64efb.png";